// speedtestConstants.js
'use strict';

export const SpeedtestState = {
  ADDING_SETTINGS: 0,
  ADDING_SERVERS: 1,
  SERVER_SELECTION_DONE: 2,
  TEST_RUNNING: 3,
  DONE: 4,
};
